import React from 'react'
import { Form, Input, Button } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { EPutPassword, NPersonal } from '../../../../models/constants'
import { effect } from '../../../../dva16'
import './index.less'

export default function Password() {
  const [form] = Form.useForm()
  function onFinish(values) {
    effect(NPersonal, EPutPassword, values)
  }
  return (
    <div id="password">
      <p>密码修改</p>
      <div className="pass-form">
        <Form form={form} name="password" onFinish={onFinish}>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: '请输入原密码',
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              size="large"
              visibilityToggle={false}
              placeholder="原密码"
              style={{ width: 450 }}
            />
          </Form.Item>

          <Form.Item
            name="newPassword"
            rules={[
              {
                required: true,
                message: '请输入新密码',
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              size="large"
              style={{ width: 450 }}
              visibilityToggle={false}
              placeholder="新密码"
            />
          </Form.Item>
          <Form.Item
            name="newPassword2"
            rules={[
              {
                required: true,
                message: '请再次输入新密码',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject('请两次输入密码一致')
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              size="large"
              style={{ width: 450 }}
              visibilityToggle={false}
              placeholder="再次输入新密码"
            />
          </Form.Item>
          <Form.Item>
            <div className="button">
              <Button htmlType="button" onClick={() => form.resetFields()} className="cancel">
                取消
              </Button>
              <Button htmlType="submit" className="save">
                保存
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}
